module.exports = __webpack_public_path__ + "media/images/icon_crown03-86757ba4540d4f64fa6090c919ea8cb9.png";